import React from "react";
import ArrowIcon from "../../../../../prod/images/redesign/arrowRight.svg?react";
import { SectionPageType } from "../../types/optimizely/sectionpage";

interface AnchorNavProps {
  content: SectionPageType;
}

export const AnchorNav: React.FC<AnchorNavProps> = ({ content }) => {
  const linkButtons = content.linkButtons.expandedValue;

  if (!linkButtons?.length) {
    return null;
  }

  return (
    <nav className="p-8 md:pb-16 md:px-14 md:pt-10">
      <div className="flex-col gap-4 grid grid-cols-1 md:grid-cols-3 grid-flow-dense">
        {linkButtons.map((link) => (
          <a
            key={link.name}
            href={`#${link.link?.expandedValue?.sectionId?.value ?? ''}`}
            className="flex items-center justify-between bg-secondaryLightGreen rounded-lg px-6 py-4 hover:no-underline group"
            aria-label={`Navigate to ${link.name}`}
          >
            <h5 className="text-primary text-lg font-medium text-md">{link.name}</h5>
            <ArrowIcon className="w-6 h-6 text-primary group-hover:translate-x-2 transition-all duration-200 ease-out" />
          </a>
        ))}
      </div>
    </nav>
  );
};
